import React, { useState } from "react"
import Modal from "./Modal"


const bg = {
    "Application Submitted": "blue",
    "Received Questionnaire": "yellow",
    "Interviewing": "purple",
    "Received Offer": "green",
    'Submitted Application': ""
}

//{el.username}
const maskedUser = "*****************"

function Item({ el }) {

    //unused
    const [open, setOpen] = useState(false)


    return (
        <h4 className={`row ${el.status === "Received Offer" && 'clickable'}`}
            onClick={() => el.status === "Received Offer" && setOpen(!open)}
        >
            <span className="id-col">{el.userId}</span>
            <span className="username-col" id="namecol">{el.status === "Received Offer" ? el.username : maskedUser}</span>
            <span className="date-col">May {el.date}</span>
            <span className="track-col">{el.track} </span>
            <span className="city-col">{el.city}</span>
            <span className={`status-col ${bg[el.status]}`}>{el.status} </span>
            <span className="date-col">{el.statusDate}</span>
            <span className="history-col" > {"+"}  </span>
            {/* <span className="history-col"> {"+"} {el.history[0].status} </span> */}
            {/* <span className="history-col" onClick={handleClick}> {"+"}  </span> */}

            {/* 
            {open && <div className="loginModal">
                {open && <div onClick={() => setOpen(false)} className="closeBtn"><i class="fa-solid fa-xmark"></i></div>}
                {open && <div className="loginCont">
                    <h3>History</h3>
                    <p>Track: {el.track}</p>
                    <p>Application Date: May {el.date}</p>
                </div>
                }
            </div>} */}


            <Modal open={open} handleClose={() => setOpen(false)}>
                <div className="wrapper">
                    <h2>Application Timeline</h2>

                    <p>Track:  {el.track}</p>
                    <p>Application Date: May {el.date}</p>
                    <p>Received Questionnaire: {el.history[0] && el.history[0].date}</p>
                    <p>Interview Invite: {el.history[1] && el.history[1].date}</p>
                    {el.history[2] && <p> Interviewed: {el.history[2].date}</p>}
                    <p>Received Offer: {el.statusDate}</p>

                </div>
            </Modal>
        </h4>
    )
}

export default Item